/**
 * Modal view ID of the SharedDocument view.
 */
export const SHARE_GENERICIFRAME_VIEW_ID = 'SHARE_GENERICIFRAME_VIEW_ID';
